<!--
frontend-author:udayasankar,
backend-author: ,
page-name :Sales by Customer.vue,
page-description :Sales by credit for invoice,
started at : 15-Apr-2019,
edited at :16-Apr-2019.
-->
<!-- Html code for Sales by Customer-->
<template>
  <div>
    <b-row class="reports-header px-pad border-bottom" style="height:42px">
      <b-col xl="10" lg="10" md="10" sm="10" class="px-0">
        <GlobalDateRangePicker
          class="pr-3"
          ref="daterangeupdate"
          :singleDatePicker="false"
          v-on:setDateRange="getDateRange($event,1)"
          :fromDate="from_date"
          :toDate="to_date"
        />
        <b-dropdown dropdown variant="light" size="sm" class="no-caret-dropdown mb-xs">
          <template slot="button-content">
            <span v-if="selectedfilter.filter_name">
              <i class="fa fa-filter la-lg mr-1"></i>
              {{selectedfilter.filter_name}}
            </span>
            <span v-else>
              <i class="la la-cog la-lg mr-1"></i>Customize Report
            </span>
          </template>
          <!-- For filter -->
          <b-dropdown-item v-b-modal.CustomerBalancesReport>General</b-dropdown-item>
          <!-- To add columns -->
          <b-dropdown-item v-b-modal.custom_index>Show/hide columns</b-dropdown-item>

          <template v-if="reportsfilter.length>0">
            <b-dropdown-divider />
            <div class="mb-2">
              <span class="pl-4 text-link fw-semi-bold">Your Custom Filters</span>
            </div>
          </template>
          <b-dropdown-item v-for="item in reportsfilter" :key="item.id">
            <div class="d-flex">
              <a
                class="report_button mb-0 w-75 text-truncate"
                @click="runcustomreport(item)"
              >{{ item.filter_name }}</a>
              <i
                class="la la-edit la-lg text-right ml-2 mr-3 ml-auto"
                @click="filterpage = 'update',filteritems=item"
                v-b-modal.savefilterform
              ></i>
              <i
                class="glyphicon glyphicon-trash text-right"
                @click="handlingapprovingmodal({
                  content : 'Are you sure you want to delete this customize filter ?',
                  title : 'Delete customize filter - '+item.filter_name,
                  module:'general/deletecustomfilter',
                  data:JSON.stringify({
                    id : item.filter_id,
                    report_type: $route.meta.title
                  }),
                  RoutePlace:'',
                  isRoute:'false',
                  type: 'delete'
                })"
              ></i>
            </div>
          </b-dropdown-item>
        </b-dropdown>
        <span
          class="btn-link cursor_pointer ml-2 fw-semi-bold"
          v-if="!selectedfilter.filter_id"
          @click="filterpage = 'create',savefilterform()"
        >Save filter</span>
      </b-col>
      <b-col xl="2" lg="2" md="2" sm="2" class="px-0">
        <router-link class="event-link float-right mt-2" :to="{ name : 'Reports'}">
          <i class="la la-remove la-lg text-decoration-none text-dark"></i>
        </router-link>
        <!-- Download excel -->
        <b-dropdown
          dropdown
          variant="light"
          size="sm"
          class="no-caret-dropdown float-right mr-2"
        >
          <template slot="button-content">
            <i class="la la-navicon la-lg"></i>
          </template>
          <b-dropdown-item class="dropdown-no-btn" @click="exportModal()">
            <span class="la la-download mx-2"></span>Export CustomerBalance
          </b-dropdown-item>
        </b-dropdown>
      </b-col>
    </b-row>
    <b-row class="pt-2">
      <b-col lg="12" xl="12" md="12" sm="12" class="px-0">
        <div class="text-center text-normal">
          <p class="mb-1">{{ org_name }}</p>
          <h4>Customer Balances</h4>
          <p class="text-sm text-muted mb-2">As of {{ getDateFormat(to_date) }}</p>
        </div>
        <!-- <GlobalLoader v-show="loader"/> -->
        <div class="table-responsive" id="reportScrollCol">
          <!--  Invoice Table-->
          <table class="table table-bordered reports-table-border table-no-bordered">
            <!--  Invoice Table head-->
            <thead class="tbl-col">
              <tr>
                <th style="min-width:180px !important">
                  <router-link
                    :to="{ name : 'CustomerBalancesReport',query: {report_date:$route.query.report_date,page: page,show: show,custom:$route.query.custom,select_columns:$route.query.select_columns,show_by:$route.query.show_by,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'cus_name'} }"
                    class="text-dark text-decoration-none"
                  >
                    Customer Name
                    <small class="text-muted" v-if="label == 'cus_name'">
                      <i
                        :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                        style="font-weight:thinner;"
                      ></i>
                    </small>
                  </router-link>
                </th>
                <th style="width:140px !important" class="text-right">
                  <router-link
                    :to="{ name : 'CustomerBalancesReport',query: {report_date:$route.query.report_date,page: page,show: show,custom:$route.query.custom,select_columns:$route.query.select_columns,show_by:$route.query.show_by,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'due_amount'} }"
                    class="text-dark text-decoration-none"
                  >
                    Invoice Bal
                    <small class="text-muted" v-if="label == 'due_amount'">
                      <i
                        :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                        style="font-weight:thinner;"
                      ></i>
                    </small>
                  </router-link>
                </th>
                <th style="width:155px !important" class="text-right">
                  <router-link
                    :to="{ name : 'CustomerBalancesReport',query: {report_date:$route.query.report_date,page: page,show: show,custom:$route.query.custom,select_columns:$route.query.select_columns,show_by:$route.query.show_by,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'total_unused_credits'} }"
                    class="text-dark text-decoration-none"
                  >
                    Unused Credits
                    <small class="text-muted" v-if="label == 'total_unused_credits'">
                      <i
                        :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                        style="font-weight:thinner;"
                      ></i>
                    </small>
                  </router-link>
                </th>
                <th style="width:140px !important" class="text-right">
                  <router-link
                    :to="{ name : 'CustomerBalancesReport',query: {report_date:$route.query.report_date,page: page,show: show,custom:$route.query.custom,select_columns:$route.query.select_columns,show_by:$route.query.show_by,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'balance'} }"
                    class="text-dark text-decoration-none"
                  >
                    Balance
                    <small class="text-muted" v-if="label == 'balance'">
                      <i
                        :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                        style="font-weight:thinner;"
                      ></i>
                    </small>
                  </router-link>
                </th>
                <!-- Customize column -->
                <th
                  :class="{'text-right':column.align=='right'}"
                  :style="{'width':column.colWidth+'px !important'}"
                  v-for="(column) in reported_columns"
                  v-if="column.checked == true"
                  :key="column.id"
                >
                  <template v-if="column.field!='export_total_unused_credits'">
                    <span :style="{'width':column.colWidth+'px !important'}">
                      <router-link
                        :to="{ name : 'CustomerBalancesReport',query: {report_date:$route.query.report_date,page: page,show: show,custom:$route.query.custom,select_columns:$route.query.select_columns,show_by:$route.query.show_by,sort:sort == 'asc' ? 'desc' : 'asc' ,label:column.field} }"
                        class="text-dark text-decoration-none"
                      >
                        {{ column.title }}
                        <small class="text-muted" v-if="label == column.field">
                          <i
                            :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                            style="font-weight:thinner;"
                          ></i>
                        </small>
                      </router-link>
                    </span>
                  </template>
                  <b-row v-else v-b-tooltip.top :title="column.title">
                    <b-col sm="10" class="pr-0">
                      <router-link
                        :to="{ name : 'CustomerBalancesReport',query: {report_date:$route.query.report_date,page: page,show: show,custom:$route.query.custom,select_columns:$route.query.select_columns,show_by:$route.query.show_by,sort:sort == 'asc' ? 'desc' : 'asc' ,label:column.field} }"
                        class="text-dark text-decoration-none"
                      >
                        <span class="text">{{ column.title }}</span>
                      </router-link>
                    </b-col>
                    <b-col sm="2" class="pl-0">
                      <small class="text-muted" v-if="label == column.field">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </b-col>
                  </b-row>
                  <!-- End of customize column header -->
                </th>
              </tr>
            </thead>
            <!--  Sales by Customer Table body and data -->
            <template v-if="lists.length == 0">
              <tbody>
                <tr>
                  <td colspan="4" class="text-center">No data to display</td>
                  <td
                    v-if="reported_columns.length > 0 && show_columns_length > 0"
                    :colspan="parseInt(reported_columns.length) - 0"
                  ></td>
                </tr>
              </tbody>
            </template>
            <template v-else>
              <tbody>
                <tr v-for="item in lists" :key="item.id" @click="oldRoute = $route.query">
                  <td style="width:180px !important">
                    <span class="text">{{ item.cus_name }}</span>
                  </td>
                  <td class="text-right">
                    <router-link
                      class="text-decoration-none"
                      :to="{ name : 'CustomerBalancesFilter',params:{id:item.cus_id,filter_by:'invoice_balance'},query: {name:item.cus_name,id: item.cus_id,filter_by:'invoice_balance',report_date:$route.query.report_date} }"
                    >{{ orgCurrencySymbol+" "+Number(item.due_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</router-link>
                  </td>
                  <td class="text-right">
                    <router-link
                      class="text-decoration-none"
                      :to="{ name : 'CustomerBalancesFilter',params:{id:item.cus_id,filter_by:'credit_balance'},query: {name:item.cus_name,id: item.cus_id,filter_by:'credit_balance',report_date:$route.query.report_date} }"
                    >{{ orgCurrencySymbol+" "+Number(item.total_unused_credits).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</router-link>
                  </td>
                  <td class="text-right">
                    <router-link
                      class="text-decoration-none"
                      :to="{ name : 'CustomerBalancesFilter',params:{id:item.cus_id,filter_by:'balance'},query: {name:item.cus_name,id: item.cus_id,filter_by:'balance',report_date:$route.query.report_date} }"
                    >{{ orgCurrencySymbol+" "+Number(item.balance).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</router-link>
                  </td>
                  <!-- Customize column -->
                  <td
                    :class="{'text-right':column.align=='right'}"
                    v-for="(column) in reported_columns"
                    v-if="column.checked == true"
                    :key="column.id"
                    :style="{'width':column.colWidth+'px !important'}"
                  >
                    <span
                      v-if="column.field=='place_of_supply'"
                    >{{ getDetails($AppDetails.state_details,item.place_of_supply,'state_name')}}</span>
                    <span
                      v-else-if="column.field=='cus_currency'"
                    >{{getDetails($AppDetails.currency_details,item.cus_currency,'currency_name')}}</span>
                    <span v-else-if="column.field=='cus_pymnt_term'"></span>
                    <span
                      v-else-if="column.field=='credit_limit'||column.field=='export_total_unused_credits'||column.field=='export_balance'||column.field=='export_due_amount'||column.field=='export_total_unused_credits'"
                    >
                      {{ getDetails(
                      $AppDetails.currency_details,
                      item.customer_currency,
                      "currency_symbol"
                      )+" "+Number(item[column.field]).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}
                    </span>

                    <span :class="{'text':column.align=='overflow'}" v-else>{{item[column.field] }}</span>
                    <!-- End of customize column data -->
                  </td>
                </tr>
                <tr>
                  <td colspan="3" class="font-weight-bold text-right">TOTAL ({{total_count}})</td>

                  <td
                    class="font-weight-bold text-right"
                  >{{ orgCurrencySymbol+" "+Number(total_amount.total_balance).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                  <td
                    v-if="reported_columns.length > 0 && show_columns_length > 0"
                    :colspan="parseInt(reported_columns.length) - 0"
                  ></td>
                </tr>
              </tbody>
            </template>
          </table>
           <p class="ml-4" v-if="lists.length != 0">Amount is displayed in your base currency <b-badge
                variant="success"
                size="xs"
                style="height:20px"
              >{{orgCurrency}}</b-badge></p>
        </div>
      </b-col>
    </b-row>

    <!-- Sales by Item pagination and data showing -->
    <b-row
      v-if="lists.length > 0||arrow"
      style="width: 100%;position: absolute;border-top:1px solid #e0e0e0"
      class="px-pad"
    >
      <b-col xl="5" md="6" lg="6" sm="8" class="mt-2 pt-1 px-0">
        <nav class="float-left" v-if="lists.length > 0">
          <p>
            Showing {{ (total_count != 0 ) ? ((page - 1) * count) + 1 : 0 }} to {{ ((page - 1) * show) + lists.length }}
            of {{ total_count }} entries
            <span
              class="btn-group dropdown"
            >
              <b-dropdown
                variant="link"
                toggle-class="text-decoration-none"
                size="xs"
                :show="false"
                :text="count"
                left
              >
                <router-link
                  :to="{ name : 'CustomerBalancesReport',query: {report_date:$route.query.report_date,page: 1,show: 10,select_columns:$route.query.select_columns,custom:$route.query.custom,show_by:$route.query.show_by,sort:sort,label:label} }"
                  class="text-dark text-decoration-none"
                >
                  <b-dropdown-item-button class="page-link" v-if="count != 10">10</b-dropdown-item-button>
                </router-link>
                <router-link
                  :to="{ name : 'CustomerBalancesReport',query: {report_date:$route.query.report_date,page: 1,show: 25,select_columns:$route.query.select_columns,custom:$route.query.custom,show_by:$route.query.show_by,sort:sort,label:label} }"
                  class="text-dark text-decoration-none"
                >
                  <b-dropdown-item-button class="page-link" v-if="count != 25">25</b-dropdown-item-button>
                </router-link>
                <router-link
                  :to="{ name : 'CustomerBalancesReport',query: {report_date:$route.query.report_date,page: 1 ,show: 50,select_columns:$route.query.select_columns,custom:$route.query.custom,show_by:$route.query.show_by,sort:sort,label:label} }"
                  class="text-dark text-decoration-none"
                >
                  <b-dropdown-item-button class="page-link" v-if="count != 50">50</b-dropdown-item-button>
                </router-link>
              </b-dropdown>
            </span> rows per page
          </p>
        </nav>
      </b-col>
      <b-col xl="2" md="2" lg="2" sm="4" style="text-align: center;" class="mt-2 pt-1 px-0">
        <div v-if="arrow">
          <a @click="left('#reportScrollCol')" class="mr-2">
            <i class="fa fa-angle-left mr-1 fw-bold round-icon"></i>

            <!-- <b-badge class="badge" variant="light">&lt;</b-badge> -->
          </a>
          <a @click="right('#reportScrollCol')">
            <i class="fa fa-angle-right ml-1 fw-bold round-icon"></i>

            <!-- <b-badge class="badge" variant="light">&gt;</b-badge> -->
          </a>
        </div>
      </b-col>
      <b-col xl="5" md="4" lg="4" sm="12" class="mt-2 pt-1 px-0 d-md-block d-none">
        <template v-if="show<total_count">
          <nav class="float-right">
            <ul class="pagination">
              <li class="page-item">
                <template v-if="page != 1">
                  <router-link
                    class="page-link"
                    :to="{ name : 'CustomerBalancesReport',query: {report_date:$route.query.report_date,page: page - 1 ,show: count,select_columns:$route.query.select_columns,custom:$route.query.custom,show_by:$route.query.show_by,sort:sort,label:label} }"
                  >
                    <span aria-hidden="true">&laquo;</span>
                    <span class="sr-only">Previous</span>
                  </router-link>
                </template>
                <template v-else>
                  <a class="page-link" href="#" aria-label="Previous">
                    <span aria-hidden="true">&laquo;</span>
                    <span class="sr-only">Previous</span>
                  </a>
                </template>
              </li>
              <li class="page-item">
                <router-link
                  class="page-link"
                  :to="{ name : 'CustomerBalancesReport',query: {report_date:$route.query.report_date,page: 1 ,show: count,select_columns:$route.query.select_columns,custom:$route.query.custom,show_by:$route.query.show_by,sort:sort,label:label} }"
                >First</router-link>
              </li>
              <li class="page-item">
                <template v-if="page != 1">
                  <router-link
                    class="page-link"
                    :to="{ name : 'CustomerBalancesReport',query: {report_date:$route.query.report_date,page: page - 1 ,show: count,select_columns:$route.query.select_columns,custom:$route.query.custom,show_by:$route.query.show_by,sort:sort,label:label} }"
                  >Previous</router-link>
                </template>
                <template v-else>
                  <a href="#" class="page-link">Previous</a>
                </template>
              </li>
              <li class="page-item">
                <template v-if="total_count > (page * count)">
                  <router-link
                    class="page-link"
                    :to="{ name : 'CustomerBalancesReport',query: {report_date:$route.query.report_date,page: page + 1,show: count,select_columns:$route.query.select_columns,custom:$route.query.custom,show_by:$route.query.show_by,sort:sort,label:label } }"
                  >Next</router-link>
                </template>
                <template v-else>
                  <a href="#" class="page-link">Next</a>
                </template>
              </li>
              <li class="page-item">
                <router-link
                  class="page-link"
                  :to="{ name : 'CustomerBalancesReport',query: {report_date:$route.query.report_date,page: Math.ceil(total_count / count),show: count,select_columns:$route.query.select_columns,custom:$route.query.custom,show_by:$route.query.show_by,sort:sort,label:label } }"
                >Last</router-link>
              </li>
              <li class="page-item">
                <template v-if="total_count > (page * count)">
                  <router-link
                    class="page-link"
                    :to="{ name : 'CustomerBalancesReport',query: {report_date:$route.query.report_date,page: page + 1,show: count,select_columns:$route.query.select_columns,custom:$route.query.custom,show_by:$route.query.show_by,sort:sort,label:label } }"
                  >
                    <span aria-hidden="true">&raquo;</span>
                    <span class="sr-only">Next</span>
                  </router-link>
                </template>
                <template v-else>
                  <a class="page-link" href="#" aria-label="Next">
                    <span aria-hidden="true">&raquo;</span>
                    <span class="sr-only">Next</span>
                  </a>
                </template>
              </li>
            </ul>
          </nav>
        </template>
      </b-col>
    </b-row>
    <!--  Model-->
    <b-modal
      id="CustomerBalancesReport"
      title="Customize Report"
      body-class="bg-white"
      size="lg"
      ref="runreport"
      ok-title="Run Report"
      @ok.prevent="selectedfilter={},onRunReport(0)"
      cancel-variant="light"
      @shown="cus_id()"
    >
      <!-- Validation for CustomerBalancesReport reports -->
      <b-row>
        <b-col xl="12" lg="12" md="12" xs="12" sm="12">
          <div class="container-fluid">
            <b-alert class="alert-transparent alert-danger" :show="error_show && this.errors.any()">
              <button type="button" @click="error_show=!error_show" class="close">
                <span aria-hidden="true">&times;</span>
              </button>
            </b-alert>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="12" lg="12" md="12" sm="12" xs="12">
          <b-row>
            <b-col xl="12" lg="12" md="12" sm="12" xs="12">
              <b-form-group label="Date" label-for="date" :label-cols="3">
                <GlobalDateRangePicker
                  :singleDatePicker="false"
                  v-on:setDateRange="getDateRange($event)"
                  :fromDate="from_date"
                  :toDate="to_date"
                />
                <input type="hidden" name="from_date" v-model.trim="from_date" />
                <input type="hidden" name="to_date" v-model.trim="to_date" />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col xl="8" lg="8" md="8" sm="8" xs="8" @click="removecustomer($event)">
              <b-form-group label="Search for customer" label-for="date" :label-cols="5">
                <vue-bootstrap-typeahead
                  @input="customerlist($event)"
                  v-model="cus_detail_id"
                  :id="'customer_search'"
                  name="cus_detail_id[]"
                  :data="customers"
                  :class="{'customer_search':true}"
                  :serializer="customer => customer.label"
                  @hit="checkCustomer($event)"
                  placeholder="Type to search customer"
                  :ref="'cus_name_typeahead'"
                />
                <input type="text" class="form-control" v-model.trim="show_by" v-show="false" />
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-modal>
    <!-- Customize column -->
    <b-modal
      :no-close-on-backdrop="true"
      id="custom_index"
      title="Customize Report"
      body-class="bg-white"
      cancel-variant="light"
      ok-title="Run Report"
      size="lg"
      @ok.prevent="selectedfilter={},onRunReport(0)"
      ref="run"
    >
      <b-row>
        <b-col>
          <p class="fw-semi-bold pl-2">General</p>
          <b-form-checkbox
            class="pt-1"
            v-model="show_columns"
            v-for="(group, index) in available_columns"
            v-if="group.Group=='customer'||group.Group=='general'||group.Group=='pymnt_terms'||group.Group=='credit_limit'||group.Group=='sales_person'||group.Group=='project'||group.Group=='gst_type'"
            :value=" {group:group.Group,field: group.field}"
            :key="index"
            @change="group.checked = !group.checked"
            style="display:block;padding-left:30px"
          >{{group.title}}</b-form-checkbox>
        </b-col>
        <b-col>
          <p class="fw-semi-bold pl-2">Customer Balance</p>
          <b-form-checkbox
            class="pt-1"
            v-model="show_columns"
            v-for="(group, index) in available_columns"
            v-if="group.Group=='export'"
            :value=" {group:group.Group,field: group.field}"
            :key="index"
            @change="group.checked = !group.checked"
            style="display:block;padding-left:25px"
          >{{group.title}}</b-form-checkbox>
        </b-col>
      </b-row>
    </b-modal>
    <SaveFilterForm :saveforfuture="saveforfuture" :page="filterpage" :item="filteritems" />
    <GlobalModal
      :content="content"
      :module="module"
      :title="title"
      :data="globalmodaldata"
      :isRoute="isRoute"
      :RoutePlace="RoutePlace"
      :type="globalmodaltype"
    />
    <GlobalExportModal
      v-if="export_modal"
      :data="export_data"
      :columns="export_xl"
      :file_name="'Customer Balaces'"
      @downloaded="export_modal=false"
    />
    <!--  back to top  -->
  </div>
</template>
<!-- Sales by Customer  Script -->
<script>
import { scrollTable } from "@/mixins/scrollTable"; //functions call for table scroll

import { mapState, mapGetters } from "vuex";
import store from "@/store/index";
import Vue from "vue";
import moment from "moment";
import $ from "jquery";
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";
import DatePicker from "vue2-datepicker";
import { formatDate } from "@/mixins/formatDate";
import SaveFilterForm from "@/pages/Reports/SaveFilterForm";
function getPageCustomerBalances(routeTo, next) {
  const currentPage = parseInt(routeTo.query.page) || 1;
  const show = parseInt(routeTo.query.show) || 10;
  const sort = routeTo.query.sort || "";
  const label = routeTo.query.label || "";
  store
    .dispatch("reports/fetchCustomerBalancesLists", {
      page: currentPage,
      show: show,
      sort: sort,
      label: label,
      query: routeTo.query
    })
    .then(() => {
      routeTo.params.page = currentPage;
      routeTo.params.show = show;
      routeTo.params.sort = sort;
      routeTo.params.label = label;
      next();
    });
}
export default {
  components: {
    DatePicker,
    VueBootstrapTypeahead,
    SaveFilterForm
  },
  props: {
    page: {
      type: Number,
      required: true
    },
    show: {
      type: Number,
      required: true
    },
    label: [String, Number],
    sort: [String, Number]
  },
  name: "CustomerBalancesReport",
  mixins: [formatDate, scrollTable],
  data() {
    return {
      arrow: false,
      export_data: [],
      export_modal: false,
      export_xl: {
        "Customer Name": "cus_name",
        "Invoice Balance": "due_amount",
        "Unused Credits": "total_unused_credits",
        " Balance": "balance"
      },
      show_columns: [],
      show_columns_length: 0,
      reported_columns: [],
      available_columns: [
        {
          Group: "customer",
          field: "cus_fname",
          title: "First Name",
          checked: false,
          colWidth: 180,
          align: "overflow"
        },
        {
          Group: "customer",
          field: "cus_lname",
          title: "Last Name",
          checked: false,
          colWidth: 180,
          align: "overflow"
        },
        {
          Group: "customer",
          field: "cus_comp_name",
          title: "Company Name",
          checked: false,
          colWidth: 180,
          align: "overflow"
        },
        {
          Group: "customer",
          field: "cus_legacy_id",
          title: "Customer ID",
          checked: false,
          colWidth: 150,
          align: ""
        },
        {
          Group: "customer",
          field: "cus_ph_no_1",
          title: "Phone",
          checked: false,
          colWidth: 110,
          align: ""
        },
        {
          Group: "customer",
          field: "cus_mail",
          title: "Mail",
          checked: false,
          colWidth: 150,
          align: "overflow"
        },
        {
          Group: "gst_type",
          field: "gst_type_name",
          title: "Gst Type",
          checked: false,
          colWidth: 210,
          align: ""
        },
        {
          Group: "customer",
          field: "cus_gst_no",
          title: "Gst No",
          checked: false,
          colWidth: 145,
          align: ""
        },
        {
          Group: "customer",
          field: "cus_pan_no",
          title: "Pan No",
          checked: false,
          colWidth: 115,
          align: ""
        },
        {
          Group: "customer",
          field: "place_of_supply",
          title: "Place of supply",
          checked: false,
          colWidth: 200,
          align: ""
        },
        {
          Group: "general",
          field: "cus_twitter_id",
          title: "Twitter id",
          checked: false,
          colWidth: 150,
          align: "overflow"
        },
        {
          Group: "general",
          field: "cus_facebook_id",
          title: "Facebook id",
          checked: false,
          colWidth: 150,
          align: "overflow"
        },
        {
          Group: "general",
          field: "cus_website",
          title: "Website",
          checked: false,
          colWidth: 150,
          align: "overflow"
        },
        {
          Group: "general",
          field: "cus_dept",
          title: "Designation",
          checked: false,
          colWidth: 150,
          align: "overflow"
        },
        {
          Group: "general",
          field: "cus_currency",
          title: "Currency",
          checked: false,
          colWidth: 180,
          align: ""
        },
        {
          Group: "pymnt_terms",
          field: "term_name",
          title: "Payment Term",
          checked: false,
          colWidth: 150,
          align: ""
        },
        {
          Group: "credit_limit",
          field: "credit_limit",
          title: "Credit Limit",
          checked: false,
          colWidth: 180,
          align: "right"
        },

        {
          Group: "export",
          field: "export_total_unused_credits",
          title: "Unused credits(FCY)",
          checked: false,
          colWidth: 155,
          align: "right"
        },
        {
          Group: "export",
          field: "export_due_amount",
          title: "Due Amt(FCY)",
          checked: false,
          colWidth: 140,
          align: "right"
        },
        {
          Group: "export",
          field: "export_balance",
          title: "Balance(FCY)",
          checked: false,
          colWidth: 140,
          align: "right"
        }
      ],
      columns: this.$route.query.show_columns,
      customers: [],
      show_by: 0,
      cus_detail_id: "",
      loader: false,
      error_show: false,
      from_date:
        this.$route.query.from_date ||
        this.formatDate(moment().startOf("month")),
      to_date:
        this.$route.query.to_date || this.formatDate(moment().endOf("month")),
      Selected: "",
      org_name: this.$AppDetails.organization.comp_name || "",
      saveforfuture: {},
      filterpage: "create",
      filteritems: "",
      isRoute: "",
      RoutePlace: "",
      content: "",
      module: "",
      globalmodaltype: "",
      globalmodaldata: "",
      title: ""
    };
  },

  updated() {
    this.arrow = this.scrollbar($("#reportScrollCol")) ? true : false;
  },
  mounted() {
    this.arrow = this.scrollbar($("#reportScrollCol")) ? true : false;
  },

  methods: {
    async exportModal() {
      this.export_modal = await true;
      this.export_data = await this.fetchExportData();
      this.$root.$emit("bv::show::modal", "exportdata");
    },
     cus_id(){
      if(this.show_by!=0){
        this.$refs.cus_name_typeahead.inputValue = this.cus_detail_id;
          $("#customer_search input").addClass("mask");
       $("#customer_search .input-group").append(
        "<span class='la la-close p-2' id='customer_remove'></span>"
      );
      $("#customer_remove").css("position", "absolute");
      $("#customer_remove").css("right", "0");
        
          
      }
    },
    async fetchExportData() {
      const currentPage = parseInt(this.$route.query.page) || 1;
      const show = parseInt(this.$route.query.show) || 10;
      const label = this.$route.query.label || "";
      const sort = this.$route.query.sort || "";
      const response = await store
        .dispatch("reports/fetchCustomerBalancesExportLists", {
          page: currentPage,
          show: show,
          sort: sort,
          label: label,

          query: this.$route.query
        })
        .then(() => {
          return this.export;
        });
      return response;
    },

    removecustomer(e) {
      if (e.target.matches("#customer_remove")) {
        $("#customer_search input").css("pointer-events", "all");
        $("#customer_search input").css("background-color", "#fff");
        $("#customer_search input").css("position", "");
        $("#customer_remove").remove();
        var cus_name = "cus_name_typeahead";
        this.$refs[cus_name].inputValue = "";
        this.show_by = "";
      }
    },
    checkCustomer(event) {
      $("#customer_search input").css("pointer-events", "none");
      $("#customer_search input").css("background-color", "#f7f7f7");
      $("#customer_search input").css("position", "relative");
      $("#customer_search .input-group").append(
        "<span class='la la-close p-2' id='customer_remove'></span>"
      );
      $("#customer_remove").css("position", "absolute");
      $("#customer_remove").css("right", "0");
      this.show_by = event.value;
    },
    customerlist(event) {
      if (event != "") {
        store.dispatch("general/fetchCustomerData", event).then(() => {
          this.customers = this.customer_filter_list;
        });
      }
    },
    getPresentValue(arr, prop, val) {
      var hasMatch = false;
      for (var i = 0; i < arr.length; i++) {
        if (arr[i][prop] == val) {
          hasMatch = true;
          break;
        }
      }
      return hasMatch;
    },
    closeModal(id) {
      this.$refs[id].hide();
    },

    runcustomreport(item) {
      this.selectedfilter = item;
      var filter_content = JSON.parse(item.filter_content);
      this.to_date = filter_content.to_date;
      this.show_columns = filter_content.show_columns;
      this.show_by = filter_content.show_by;
      this.available_columns = filter_content.available_columns;
      this.onRunReport(0);
    },
    //  delete whole invoice
    handlingapprovingmodal(ev) {
      this.content = ev.content;
      this.module = ev.module;
      this.globalmodaldata = ev.data;
      this.title = ev.title;
      this.isRoute = ev.isRoute;
      this.RoutePlace = ev.RoutePlace;
      this.globalmodaltype = ev.type;
      this.$root.$emit("bv::show::modal", "handlingapprovingmodal");
    },
    onRunReport(runreport) {
      this.$validator.validateAll().then(result => {
        if (result) {
          if (runreport == 0 && this.$refs.daterangeupdate) {
            var child = this.$refs.daterangeupdate;
            child.checkConsole({
              startDate: this.from_date,
              endDate: this.to_date
            });
          }
          this.reported_columns = JSON.parse(
            JSON.stringify(this.available_columns)
          );
          this.show_columns_length = JSON.parse(
            JSON.stringify(this.show_columns)
          ).length;
          //To add export columns for customize field
          for (var i = 0; i < this.reported_columns.length; i++) {
            if (this.reported_columns[i].checked == true) {
              this.export_xl[
                this.reported_columns[i].title
              ] = this.reported_columns[i].field;
            } else {
              delete this.export_xl[this.reported_columns[i].title];
            }
          }
          this.saveforfuture = {
            to_date: this.to_date,
            show_columns: this.show_columns,
            show_by: this.show_by,
            available_columns: this.available_columns
          };
          var show_by = this.show_by != 0 ? this.show_by : "";
          this.$router.push({
            name: this.$route.name,
            query: {
              report_date: this.to_date,
              select_columns: JSON.stringify({
                columns: JSON.stringify(this.show_columns)
              }),
              show_by
            }
          });
        } else {
          this.error_show = true;
        }
      });
    },
    getDateRange(event, runreport) {
      this.from_date = event.startDate;
      this.to_date = event.endDate;
      if (runreport == 1) {
        this.onRunReport();
      }
    },
    changeSelectOption(field, value) {
      Vue.set(this, field, value);
    }
  },
  created() {
    if (!$.isEmptyObject(this.selectedfilter)) {
      this.runcustomreport(this.selectedfilter);
    } else if (
      Object.entries(this.$route.query).length === 0 &&
      this.$route.query.constructor === Object
    ) {
      this.$router.push({
        name: this.$route.name,
        query: {
          report_date: this.to_date,
          select_columns: JSON.stringify({
            columns: JSON.stringify(this.show_columns)
          })
        }
      });
    }
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    store.dispatch(
      "general/getallcustomfilter",
      JSON.stringify({
        report_type: routeTo.meta.title
      })
    );
    getPageCustomerBalances(routeTo, next);
  },
  beforeRouteUpdate(routeTo, routeFrom, next) {
    typeof this.$refs.runreport != "undefined"
      ? this.$refs.runreport.hide()
      : "";
    typeof this.$refs.run != "undefined" ? this.$refs.run.hide() : "";
    getPageCustomerBalances(routeTo, next);
  },
  computed: {
    ...mapState({
      customer_filter_list: state => state.general.customer_filter_list,
      lists: state => state.reports.lists,
      total_count: state => state.reports.total_count,
      count: state => state.reports.count,
      total_amount: state => state.reports.total_amount,
      export: state => state.reports.export,
      reportsfilter: state => state.general.reportsfilter
    }),
    selectedfilter: {
      get() {
        return this.$store.state.general.selectedfilter;
      },
      set(val) {
        this.$store.state.general.selectedfilter = val;
      }
    },
    ...mapGetters(["orgCurrencySymbol","orgCurrency"]),
    oldRoute: {
      get() {
        return this.$store.state.general.oldRoute;
      },
      set(val) {
        this.$store.state.general.oldRoute = val;
      }
    }
  }
};
</script>

<!--  Sales by Customer style -->
<style scoped>
.pagination > .page-item > .page-link,
.pagination > .page-item > span {
  border-radius: unset;
  margin: 0;
  background: transparent;
}
.ver-align {
  padding-top: 10px;
  text-decoration: none;
}
.content {
  position: relative;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  padding: 40px 40px 60px;
  background-color: #fff;
}
</style>
